import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

const Index = () => import('./Index.vue');
const ConnectionConfig = () => import('./ConnectionConfig.vue');
const OAuthCallback = () => import('./OAuthCallback.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/data-hub'),
      component: SettingsWrapper,
      props: { keepAlive: false },
      children: [
        {
          path: '',
          name: 'settings_data_hub_index',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
        {
          path: 'new',
          name: 'settings_data_hub_new',
          meta: {
            permissions: ['administrator'],
          },
          component: ConnectionConfig,
        },
        {
          path: ':connectionId/edit',
          name: 'settings_data_hub_edit',
          meta: {
            permissions: ['administrator'],
          },
          component: ConnectionConfig,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/data-hub/oauth/callback'),
      name: 'settings_data_hub_oauth_callback',
      meta: {
        permissions: ['administrator'],
      },
      component: OAuthCallback,
    },
  ],
};
